import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { Buffer } from 'buffer'
import {BrowserRouter} from 'react-router-dom';
import analyticsSetUp from './core/analytics';
Amplify.configure(awsExports);
window.Buffer = window.Buffer || Buffer;

analyticsSetUp()

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
